import * as types from 'store/mutation-types'
import api from './api'
import builderApi from '../builder/api'

export default {
  async [types.GET_DRAFT_CHECKOUTS] ({ commit }) {
    const drafts = await api.getCheckoutList()

    commit(types.SET_DRAFT_CHECKOUTS, drafts)
  },
  async [types.GET_PUBLISHED_CHECKOUTS] ({ commit }) {
    const published = await api.getCheckoutList(true)

    commit(types.SET_PUBLISHED_CHECKOUTS, published)
  },
  async [types.GET_TEMPLATES] ({ commit }, showInactive) {
    const templates = await api.getTemplateList(showInactive)

    commit(types.SET_TEMPLATES, templates)
  },
  async [types.REFRESH_CHECKOUT_LIST] ({ commit }) {
    commit(types.CLEAR_CHECKOUT_LIST)
    const checkoutList = await api.getCheckoutList()
    const currentCheckoutList = await api.getCheckoutList(true)
    commit(types.REFRESH_CHECKOUT_LIST, { checkoutList, currentCheckoutList })
  },
  async [types.CHECKOUT_ACTIVE_TOGGLE] ({ state, commit }, { checkoutId, index }) {
    let currentList = JSON.parse(JSON.stringify(state.checkoutList))
    let lastActiveIndex = null
    let lastCheckoutId = null

    delete currentList[index]

    currentList.forEach((current, key) => {
      if (current.isPublished) {
        lastActiveIndex = key
        lastCheckoutId = current.id
      }
    })

    if (lastActiveIndex !== null) {
      await api.checkoutActiveToggle(lastCheckoutId)
      commit(types.CHECKOUT_ACTIVE_DISABLE, { checkoutId: lastCheckoutId, index: lastActiveIndex })
    }

    await api.checkoutActiveToggle(checkoutId)
    commit(types.CHECKOUT_ACTIVE_TOGGLE, { checkoutId, index })
  },
  async [types.DELETE_CHECKOUT] ({ commit, dispatch }, checkoutId, couponId) {
    await api.deleteCheckout(checkoutId, couponId)
    dispatch(types.REFRESH_CHECKOUT_LIST)
  },
  [types.SET_THIS_CHECKOUT_ACTIVE] ({ commit, state }, { id, published }) {
    const { draftCheckouts, publishedCheckouts } = state

    let currentList = draftCheckouts

    if (published) {
      currentList = publishedCheckouts
    }

    const checkoutData = currentList.find(current => id === current.id)

    commit(types.SET_CHECKOUT_DATA, checkoutData)
  },
  [types.CLEAR_CHECKOUT_DATA] ({ commit }) {
    commit(types.SET_CHECKOUT_DATA, null)
  },
  async [types.GET_HOTLINKS_FOR_CURRENT_PRODUCT] ({ commit, state, rootState, dispatch }, { mainOfferText, offerCodeText, defaultCheckoutText }) {
    const promises = state.publishedCheckouts.map(async function (publishedCheckout) {
      const { data } = await api.getHotlinks(publishedCheckout.id)

      const offerList = data

      let newOfferList = []

      if (offerList.length === 1 && offerList[0].idProduct) {
        newOfferList.push({
          key: 'default-checkout',
          description: defaultCheckoutText,
          hotlink: offerList[0].hotlink
        })

        return {checkoutId: publishedCheckout.id, offers: newOfferList, status: publishedCheckout.status}
      }

      const { offers: currentProductOffers = [] } = rootState.auth.currentProductData

      offerList.forEach(currentOfferItem => {
        currentProductOffers.forEach(offerItem => {
          const commonOfferCheck = currentOfferItem.offerKey === offerItem.key
          const mainOfferCheck = !currentOfferItem.offerKey && offerItem.mainOffer
          const offerDestription = offerItem.description || `${offerCodeText}: ${offerItem.key}`
          const description = offerItem.mainOffer ? mainOfferText : offerDestription

          if (commonOfferCheck || mainOfferCheck) {
            newOfferList.push({
              ...offerItem,
              description,
              hotlink: currentOfferItem.hotlink
            })
          }
        })
      })

      return {checkoutId: publishedCheckout.id, offers: newOfferList, status: publishedCheckout.status}
    })

    const hotlinks = await Promise.all(promises)
    commit(types.SET_CURRENT_PRODUCT_HOTLINKS, hotlinks)
  },
  async [types.PUBLISH_CHECKOUT] ({ commit, state, dispatch }, {offers}) {
    await api.activeCurrentCheckout(state.checkoutData.id, offers)

    const { data: newCheckoutData } = await builderApi.getCheckout(state.checkoutData.id)

    dispatch('datahubEvents/SEND_PUBLISHED_COMPONENTS_EVENT_TO_DATAHUB', {
      activeType: newCheckoutData.status,
      checkoutId: state.checkoutData.id,
      checkoutData: newCheckoutData
    }, { root: true })

    return newCheckoutData
  },
  async [types.DUPLICATE_CHECKOUT] ({state, commit, dispatch, rootState}) {
    const { data: checkoutData } = await api.getCheckoutData(state?.checkoutData?.id)

    const clonedPayload = checkoutData.payloadList.map(current => {
      return {
        locale: current.locale,
        checkoutMode: current.checkoutMode,
        payloadFileList: current.payloadFileList || [],
        payload: current.payload,
        isPublished: true
      }
    })

    const clonedCheckoutData = {
      idProduct: parseInt(rootState.auth.currentProduct),
      name: checkoutData.name + ' (clone)',
      payloadList: clonedPayload
    }

    const { status } = await builderApi.cloneCheckout(clonedCheckoutData)

    return status === 200
  },

  async [types.DUPLICATE_CHECKOUT_OTHER_PRODUCTS] ({state, commit, dispatch}, {productsIds}) {
    const { data: checkoutData } = await api.getCheckoutData(state?.checkoutData?.id)

    const clonedPayload = checkoutData.payloadList.map(current => {
      return {
        locale: current.locale,
        checkoutMode: current.checkoutMode,
        payloadFileList: current.payloadFileList || [],
        payload: current.payload,
        isPublished: true
      }
    })

    const clonedCheckoutData = {
      idProducts: productsIds,
      name: checkoutData?.name + ' (clone)',
      payloadList: clonedPayload
    }

    const { status } = await builderApi.cloneCheckoutFromOtherProducts(clonedCheckoutData)

    return status === 200
  }
}
